import { ofType } from 'redux-observable';
import { Observable, concatMap, filter, of } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import type { AppEpic, AppThunk, AppThunkDispatch } from 'src/store.types';
import type { AppState } from 'src/reducers';
import { setRightContainerPayload } from '../RightContainer/RightContainer.slice';
import { RightContainerPayloadType } from '../RightContainer/RightContainer';
import { getChats, getAgentConfig, createChat } from './Agent.actions';
import { mockRequestScope, receiveAgentMessage } from './Agent.slice';
import { AgentActionType } from './Agent.types';
import { asyncGetScope } from '../AssortmentScopeSelector/AssortmentScopeSelector.actions';
import { getFilters } from '../FilterPanel/FilterPanel.container';
import { setActivePage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { last, noop } from 'lodash';
import { toastAndLog } from 'src/services/loggingService';

export const handleFetchAgentData: AppEpic = (action$): Observable<AppThunk> => {
  return action$.pipe(
    ofType(setRightContainerPayload.type),
    filter((r) => {
      return r.payload.type === RightContainerPayloadType.Agent;
    }),
    concatMap(() => of(getChats(), getAgentConfig())),
  );
};

export const handleReceivedAgentActions: AppEpic = (action$, state$: Observable<AppState>): Observable<any> => {
  return action$.pipe(
    ofType(receiveAgentMessage.type, mockRequestScope.type),
    withLatestFrom(state$),
    concatMap(([_action, state]) => {
      const conversations = state.agent.conversations;
      const convo = last([...conversations.values()]);
      const lastMessage = last(convo?.messages);
      const actions = lastMessage?.actions ?? [];

      const thunk = async (dispatch: AppThunkDispatch) => {
        for (const agentAction of actions) {
          switch (agentAction.type) {
            case AgentActionType.scopeRefresh:
              await dispatch(asyncGetScope());
              break;
            case AgentActionType.filterRefresh:
              await dispatch(getFilters());
              break;
            case AgentActionType.requestApproval:
              noop();
              break;
            case AgentActionType.navigate:
              dispatch(setActivePage({ url: '/bottom-up/hindsighting/style-color-review/canvas-view' }));
              break;
            case AgentActionType.processing:
              noop();
              break;
            default:
              // TODO: add real error handling here once we have a backend and stuff
              toastAndLog('An error occured processing actions from the llm');
          }
        }
      };

      return of(thunk);
    }),
  );
};

export const handleEmptyChats: AppEpic = (action$): Observable<AppThunk> => {
  return action$.pipe(
    ofType(getChats.fulfilled.type),
    filter((action) => {
      return Array.isArray(action.payload) && action.payload.length === 0;
    }),
    concatMap(() => of(createChat())),
  );
};
